import * as React from "react";
import { Alert } from "@mui/material";

interface Idart2ServiceWarningNotificationProps {
    isVisible: boolean;
    idart1TenantName?: string;
    serviceTenantName?: string;
    onDismiss?: () => void;
}

export default function Idart2ServiceWarningNotification(props: Idart2ServiceWarningNotificationProps) {
    const { isVisible, idart1TenantName, serviceTenantName, onDismiss } = props;

    if (!isVisible) {
        return null;
    }

    const normalizeTenantName = (value: string) => value.trim().replace(/\s+/g, "-").toLowerCase();
    const hasTenantMismatch = Boolean(
        idart1TenantName &&
        serviceTenantName &&
        normalizeTenantName(idart1TenantName) !== normalizeTenantName(serviceTenantName)
    );

    return (
        <Alert
            severity="warning"
            onClose={onDismiss}
            sx={{ borderRadius: 0, py: 0 }}
        >
            {hasTenantMismatch ?
                <>
                    The iDART Background Service is managed by iDART2 for <strong>{serviceTenantName}</strong>.
                    {" "}Open iDART2 to manage HDC and RDC devices for <strong>{idart1TenantName}</strong>.
                </> :
                <>
                    The iDART Background Service has been installed by iDART2. HDC and RDC devices should be managed
                    through iDART2.
                </>}
        </Alert>
    );
}

export type { Idart2ServiceWarningNotificationProps };
